import React from "react";
import { createRoot } from 'react-dom/client';
import "./index.scss";
import { pdfjs } from 'react-pdf';
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { createStore } from "redux";
import reducers from "./reducers";
import Routing from "./routes";
import 'bootstrap/dist/css/bootstrap.min.css';
// import '../src/Components/assets/css/custom.css';
import '../src/Components/assets/css/style.css';
import '../src/Components/assets/css/responsive.css';
import '../src/Components/assets/css/survey.scss';
import '../src/Components/assets/css/library.scss';
import  '../src/Components/assets/css/trial-completion-table.scss';
import '../src/Components/assets/css/onesource-backend.scss';
import '../src/Components/assets/css/vwd-backend.scss';
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
const root = createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <>
  
    <Provider store={createStore(reducers)}>
      <Routing />
    </Provider>
    </>
  // </React.StrictMode>,
  // document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
